import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import "amfe-flexible";
Vue.config.productionTip = false;
Vue.prototype.isMobile = ismb();
function ismb() {
  const userAgentInfo = navigator.userAgent;
  console.log(userAgentInfo);
  const mobileAgents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  for (let i = 0; i < mobileAgents.length; i++) {
    console.log(0);
    if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
      console.log(1);
      return true; // 是移动设备
    }
  }
  console.log(2);
  return false; // 是PC设备
}
console.log(Vue.prototype.isMobile);
// process.env.VUE_APP_MOBILE = Vue.prototype.isMobile ? "true" : "false";
// console.log(process.env.VUE_APP_MOBILE);
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
